// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__CsJNj","colMin":"styles_colMin__3xhRQ","colCheckbox":"styles_colCheckbox__16B-E"};